var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-img-box-p"},_vm._l((_vm.reprotImgs),function(img,index){return _c('img',{key:index,staticStyle:{"width":"100%"},attrs:{"src":img.pic || img,"alt":""}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }